import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../pages/laudo/etapas/material/material.action';
import * as commonActions from '../../app/common/common.action';
import * as usuarioActions from '../../app/common/usuario/usuario.action';
import * as tarefasActions from '../../pages/tarefas/tarefas.action';
import jwt_decode from 'jwt-decode';
import {
  removeUsuarioLocalStorage,
  removeTokenLocalStorage,
  getTokenLocalStorage,
  getUsuarioLocalStorage
} from '../../localStorage.util';
import RecolhimentoMultiContainer from '../../app/common/recolhimento/recolhimento.multi.container';
import MenuItem from './menuItem/menuItem.component';
import './menu.styles.css';
import * as acessos from '../../acessos.const.util';
import { acessoPermitido } from '../../acessos.seguranca';
import { verificaLogin } from '../../acessosLogin';
import { development, localeOptions, versionSystem } from '@constants/defaultValues';
import { setCurrentLanguage } from '../../helpers';
import * as editor from '@componentes/editor/editor.util';
import IntlMessage from '../../helpers/intlMessage';

class MenuComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.developement = development;
    this.versionSystem = versionSystem;
  }

  componentDidUpdate() {
    this.props.tarefasActions.isFirstLoad(true);
  }

  onLang(e) {
    setCurrentLanguage(e.id);
    const laudo = this.props.detalhes ? this.props.detalhes.laudo : '';
    const etapa = this.props.etapa;
    if (laudo && etapa) {
      // const { dispatch } = this.props;
      // editor.Inicializar(laudo, etapa, dispatch);
    }
    this.props.commonActions.atualizaIdioma(e.id);
  }

  logout() {
    removeUsuarioLocalStorage();
    removeTokenLocalStorage();
  }

  toggleModalRecolhimentoMulti() {
    this.props.actions.estadoMenuLateral(true);
    this.props.commonActions.mudarStatusModalRecolhimentoMulti(
      !this.props.modalRecolhimentoMulti
    );
  }

  getUsuario = async () => {
    return new Promise(resolve => {
      try {
        const usuarioLocalStorage = getUsuarioLocalStorage();
        const token = getTokenLocalStorage();
        const key = token && token.replace('bearer ', '');

        if (usuarioLocalStorage === null || key === null) {
          window.location.replace('/' + process.env.REACT_APP_LOGINPAGE);
          this.props.usuarioActions.atualizarUsuario({});
        } else if (this.props.usuario.medicoId === 0) {
          const CryptoJS = require('crypto-js');
          this.props.usuarioActions.atualizarUsuario(usuarioLocalStorage);
          const transitmessage = usuarioLocalStorage.role;
          const transitencrypted = transitmessage.substring(64);
          const decoded = jwt_decode(key);
          const decrypted = CryptoJS.AES.decrypt(
            transitencrypted,
            decoded.jti
          ).toString(CryptoJS.enc.Utf8);
          this.props.usuarioActions.permissaoUsuario(JSON.parse(decrypted));
          this.props.commonActions.showFadeCarregando(false);
          resolve();
        }
      } catch (error) {
        console.log('crypterror', error);
      }

    });
  };

  async UNSAFE_componentWillMount() {
    await this.getUsuario();
    verificaLogin(this.props.intl);
  }

  render() {
    return (
      <div>

        <Modal
          size='lg'
          isOpen={this.props.modalRecolhimentoMulti}
          toggle={() => this.toggleModalRecolhimentoMulti()}
        >
          <ModalHeader toggle={() => this.toggleModalRecolhimentoMulti()}>
            <IntlMessage id="dashboards.examDetail.sampleCollection" />
          </ModalHeader>
          <ModalBody>
            <RecolhimentoMultiContainer />
          </ModalBody>
          <ModalFooter>
            <Button
              className='modalCancel'
              color='secondary'
              onClick={() => this.toggleModalRecolhimentoMulti()}
            >
              <IntlMessage id='dashboards.disposalMaterials.modal.cancel'/>
            </Button>
          </ModalFooter>
        </Modal>

        <div
          className={'menu-fade ' + (this.props.collapsed ? 'close' : 'open')}
          onClick={() =>
            this.props.actions.estadoMenuLateral(!this.props.collapsed)
          }
        ></div>
        <div
          className={
            'menu-mv-container ' + (this.props.collapsed ? 'close' : 'open')
          }
        >

          <ul className='menu'>
            {!this.props.collapsed &&
              <div className='menu-lang'>
                <UncontrolledDropdown className="mb-2 d-none d-sm-block ">
                  <DropdownToggle color="light" size="sm" className="language-button">
                    <div className="flags">

                      <div className={`phoca-flag ${this.props.locale ? localeOptions.find((x) => x.id.toLowerCase() === this.props.locale.toLowerCase()).flag : ''}`}></div>
                      <div className="select-lang">{this.props.locale ? localeOptions.find((x) => x.id.toLowerCase() === this.props.locale.toLowerCase()).name : ''}</div>
                    </div>
                  </DropdownToggle>
                  <DropdownMenu >
                    {localeOptions.map((l) => (
                      <DropdownItem className="flag-item" onClick={() => this.onLang(l)} key={l.id}>
                        <div className="flags">
                          <div className={`phoca-flag ${l.flag}`}></div>
                          <div className="select-lang">{l.name}</div>
                        </div>
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>
                <span className="menu-titulo"></span>
              </div>}
            <MenuItem
              icone='mv-basico-casa'
              title={this.props.intl.formatMessage({ id:"menu.start" })}
              path='/'
              history={this.props.history}
            />
            {acessoPermitido(this.props.usuario, acessos.Laudos) &&
              acessoPermitido(this.props.usuario, acessos.Recolhimento) && (
                <MenuItem
                  icone='fas fa-prescription-bottle-alt'
                  history={this.props.history}
                  title={this.props.intl.formatMessage({ id:"menu.retreat" })}
                  onClick={() => this.toggleModalRecolhimentoMulti()}
                />
              )}
            {/* <MenuItem
              icone='fas fa-chart-pie'
              history={this.props.history}
              title={this.props.intl.formatMessage({ id:"menu.graphics" })}
              path='/graficos'
            /> */}

            <MenuItem
              icone='fas fa-microscope'
              history={this.props.history}
              title={this.props.intl.formatMessage({ id:"menu.histology" })}
              path='/histologia'
            />
            <MenuItem
              icone='fas fa-disease'
              history={this.props.history}
              title={this.props.intl.formatMessage({ id:"menu.generalCytology" })}
              path='/citologia'
            />
            <MenuItem
              icone='fas fa-eye-dropper'
              history={this.props.history}
              title={this.props.intl.formatMessage({ id:"menu.immunology" })}
              path='/imunologia'
            />
            <MenuItem
              icone='mv-basico-consulta'
              history={this.props.history}
              title={this.props.intl.formatMessage({ id:"menu.taskControl" })}
              path='/controle-tarefas'
            />

            <MenuItem
              icone='fa fa-user-md'
              history={this.props.history}
              title={this.props.intl.formatMessage({ id:"menu.doctorTasks" })}
              path='/tarefas-medico'
            />
            {acessoPermitido(
              this.props.usuario,
              acessos.ConsultaDescarteMateriais
            ) && (
                <MenuItem
                  history={this.props.history}
                  icone='mv-basico-excluir'
                  title={this.props.intl.formatMessage({ id:"menu.materialDisposal" })}
                  badge={this.props.totalMateriaisavencer}
                  path='/descarte-material'
                />
              )}
            <MenuItem
              icone='mv-basico-arquivar'
              history={this.props.history}
              title={this.props.intl.formatMessage({ id:"menu.archivingRequisitionMaterials" })}
              path='/arquivamento'
            />
            <MenuItem
              icone='mv-basico-report'
              history={this.props.history}
              title={this.props.intl.formatMessage({ id:"menu.reports" })}
              path='/relatorios'
            />

            <MenuItem
              icone='mv-basico-dados_solicitacao'
              history={this.props.history}
              title={this.props.intl.formatMessage({ id:"menu.requestsPanel" })}
              path='/solicitacoes'
            />

            <div className='versao'>
              <p>
                <IntlMessage id="menu.version" />{' '}
               {versionSystem}
              </p>
            </div>
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    usuario: state.usuario,
    detalhes: state.commonReducer.detalhes,
    etapa: state.commonReducer.etapa.etapa,
    locale: state.commonReducer.lang,
    collapsed: state.recebimentoMaterial.collapsedMenu,
    modalRecolhimentoMulti: state.commonReducer.modalRecolhimentoMulti,
    totalMateriaisavencer: state.descarteCommon.totalMateriaisavencer
  };
};

const mapDispacthToProps = dispatch => {
  return {
    dispatch: dispatch,
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    usuarioActions: bindActionCreators(usuarioActions, dispatch),
    tarefasActions: bindActionCreators(tarefasActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(MenuComponent);



// WEBPACK FOOTER //
// ./src/componentes/menu/menu.component.js